/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiorderProfileDisplay.ts        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/ediorder-profile-display";

export class AutogenModelEdiorderProfileDisplay<RowType extends ModelRow> extends Endpoint<RowType, RowEdiorderProfileDisplayFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiorderProfileDisplay extends ModelRow<RowEdiorderProfileDisplayFields> {
	constructor(values?: Partial<RowEdiorderProfileDisplayFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiorderProfileDisplayFields {
	ack_xmit_method: string;
	agent_payee_id: string;
	alt_partner_id: string;
	apply_chassis_adds: string;
	apply_container_adds: string;
	apply_frt_adds: string;
	apply_frt_chgs: string;
	apply_frt_dels: string;
	apply_hdr_adds: string;
	apply_hdr_chgs: string;
	apply_hdr_dels: string;
	apply_move_chgs: string;
	apply_note_adds: string;
	apply_note_dels: string;
	apply_oc_adds: string;
	apply_oc_chgs: string;
	apply_oc_dels: string;
	apply_order_chgs: string;
	apply_refno_adds: string;
	apply_refno_chgs: string;
	apply_refno_dels: string;
	apply_stop_adds: string;
	apply_stop_chgs: string;
	apply_stop_dels: string;
	auto_add_carrier: string;
	auto_add_location: string;
	auto_cancel: string;
	auto_compare: string;
	auto_compare_rt: string;
	auto_create_edi_loc: string;
	auto_create_order: string;
	auto_create_reply: string;
	auto_rate: string;
	auto_send_reply: string;
	auto_send_tender: string;
	bl_updates_order: string;
	carrier_id: string;
	clear_old_changes: string;
	collection_method: string;
	commodity_id: string;
	company_id: string;
	compare_confirm: string;
	compare_exis_stops: string;
	compare_new_stops: string;
	compare_update: string;
	complete_document: string;
	copy_from_company: string;
	create_shipstatus: string;
	currency_type_id: string;
	days_to_retain: number;
	decl_req_reason: string;
	def_move_type: string;
	direction: string;
	document_compared: string;
	dup_cutoff_days: number;
	edi_carrier: string;
	edi_comm_id: number;
	edi_customer_id: string;
	edi_customer_name: string;
	edi_customer_scac: string;
	"edi_template.ack_required": string;
	"edi_template.app_receiver_code": string;
	"edi_template.app_receiver_id": string;
	"edi_template.app_sender_code": string;
	"edi_template.app_sender_id": string;
	"edi_template.authen_info": string;
	"edi_template.authen_info_qual": string;
	"edi_template.company_id": string;
	"edi_template.ctl_version": string;
	"edi_template.ctl_version_qual": string;
	"edi_template.descr": string;
	"edi_template.direction": string;
	"edi_template.ele_separator": number;
	"edi_template.end_of_line_1": number;
	"edi_template.end_of_line_2": number;
	"edi_template.filepath": string;
	"edi_template.format_type": string;
	"edi_template.functional_id": string;
	"edi_template.id": number;
	"edi_template.industry": string;
	"edi_template.is_multi_partner": string;
	"edi_template.name": string;
	"edi_template.parse_batch_number": string;
	"edi_template.parse_create_date": string;
	"edi_template.parse_create_datef": string;
	"edi_template.parse_fg_segment": string;
	"edi_template.parse_tran_ctrl_no": string;
	"edi_template.parse_tran_segment": string;
	"edi_template.receiver_id": string;
	"edi_template.receiver_qual": string;
	"edi_template.secur_info": string;
	"edi_template.secur_info_qual": string;
	"edi_template.sender_id": string;
	"edi_template.sender_qual": string;
	"edi_template.spec_footer_text": string;
	"edi_template.spec_header_text": string;
	"edi_template.spec_title": string;
	"edi_template.standard": string;
	"edi_template.subele_separator": number;
	"edi_template.tag_format_text": string;
	"edi_template.test_indicator": string;
	"edi_template.transaction_set": string;
	"edi_template.transaction_type": string;
	"edi_template.translation_method": string;
	"edi_template.update_date": Date;
	"edi_template.version": string;
	enable_load_analyzer: string;
	enable_tl_wizard: string;
	enf_batch_cont_204: string;
	enf_batch_cont_990: string;
	enf_batch_cont_997: string;
	equipment_type_id: string;
	fa_threshold: number;
	filename: string;
	func_ack_filename: string;
	func_ack_st02_frmt: string;
	func_ack_tid: number;
	func_altpartner_id: string;
	func_comm_id: number;
	func_next_batch: number;
	func_partner_id: string;
	func_use_m_batch: string;
	func_version: string;
	id: string;
	ignore_map_errors: string;
	ignore_old_changes: string;
	intercompany: string;
	lock_miles: string;
	next_batch: number;
	notes: string;
	old_changes_reply: string;
	operations_user: string;
	order_type_id: string;
	override_reply: string;
	override_warning: string;
	partner_code_car: string;
	partner_code_loc: string;
	partner_id: string;
	partner_name: string;
	partner_status: string;
	payee_expense_glid: string;
	payee_pay_freq: string;
	payee_pay_method: string;
	pieces_info: string;
	primary_agency: string;
	process_as: string;
	process_priority: number;
	prompt_xref_edi_loc: string;
	rate_info: string;
	rbd_timezone_id: string;
	remove_file: string;
	reply_altpartnerid: string;
	reply_comm_id: number;
	reply_filename: string;
	reply_next_batch: number;
	reply_partner_id: string;
	reply_st02_format: string;
	reply_tid: number;
	reply_use_m_batch: string;
	reply_version: string;
	reply_xmit_method: string;
	require_loc_code: string;
	requires_reply: string;
	respond_within: number;
	revenue_code_id: string;
	rply_rquired_cance: string;
	rply_rquired_chang: string;
	rply_rquired_orig: string;
	scac: string;
	seg_alloc_code: string;
	send_func_ack: string;
	send_to_company: string;
	special_processing: string;
	st02_format: string;
	template_id: number;
	transaction_set: string;
	transmit_method: string;
	use_master_batch: string;
	version: string;
	weight_info: string;
	when_to_send_code: string;
	edi_customer: string;
}

